<div class="user-login-wrapper">
  <div class="user-login-container" fxLayout="column">
    <div class="user-avatar-name" (click)="userMenu.toggle($event)" fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="1em">
      <span style="cursor: pointer;font-weight: bold">{{user.first_name}} {{user.last_name}}</span>
      <mat-icon class="user-avatar-name-caret-down" >keyboard_arrow_down</mat-icon>   
      <mat-icon svgIcon="fi_user_login"></mat-icon>
    </div>
    <p-menu  [model]="items" #userMenu [popup]="true"></p-menu>
  </div>
</div>
